import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "button"];

  connect() {
    this.boundHide = this.hide.bind(this);
  }

  disconnect() {
    document.removeEventListener("click", this.boundHide, true);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const isHidden = this.menuTarget.classList.contains("hidden");
    
    if (isHidden) {
      // Menu is opening - add click listener
      this.menuTarget.classList.remove("hidden");
      setTimeout(() => {
        document.addEventListener("click", this.boundHide, true);
      }, 100);
    } else {
      // Menu is closing - remove click listener
      this.menuTarget.classList.add("hidden");
      document.removeEventListener("click", this.boundHide, true);
    }
  }

  close() {
    // Close menu without preventing default - allows anchor links to work
    this.menuTarget.classList.add("hidden");
    document.removeEventListener("click", this.boundHide, true);
  }

  hide(event) {
    // Don't hide if clicking inside the nav element
    if (this.element.contains(event.target)) {
      return;
    }
    
    // Hide menu and remove listener
    this.menuTarget.classList.add("hidden");
    document.removeEventListener("click", this.boundHide, true);
  }
}

